import sithMesStoresMst from "@/store/sithMes/mst/moduleIndex-store-sithMes-mst";
import sithMesStoresAndon from "@/store/sithMes/andon/moduleIndex-store-sithMes-andon";
import sithMesStoresPrd from "@/store/sithMes/prd/moduleIndex-store-sithMes-prd";
import sithMesStoresPrdManural from "@/store/sithMes/prd/moduleIndex-store-sithMes-prd-manural";
import sithMesStoresQuality from "@/store/sithMes/quality/moduleIndex-store-sithMes-quality";
import sithMesStoresInventory from "@/store/sithMes/inventory/moduleIndex-store-sithMes-inventory";
import sithMesStoresStool from "@/store/sithMes/stool/moduleIndex-store-sithMes-stool";
import sithMesStoresRita from "@/store/sithMes/rita/moduleIndex-store-sithMes-rita";
import sithMesStoresTpm from "@/store/sithMes/tpm/moduleIndex-store-sithMes-tpm";
import sithMesStoresCustomer from "@/store/sithMes/customer/moduleIndex-store-sithMes-customer";
import sithMesAgreementStore from "@/store/sithMes/agreement/moduleIndex-store-sithMes-agreement";

const entities = {
    ...sithMesStoresMst,
    ...sithMesStoresAndon,
    ...sithMesStoresPrd,
    ...sithMesStoresPrdManural,
    ...sithMesStoresQuality,
    ...sithMesStoresInventory,
    ...sithMesStoresStool,
    ...sithMesStoresRita,
    ...sithMesStoresTpm,
    ...sithMesStoresCustomer,
    ...sithMesAgreementStore,
}

export default entities
